import { gql } from '@apollo/client';

export const GET_TEAM = gql`
  query GetTeam($teamId: ID!) {
    getTeam(teamId: $teamId) {
      id
      nameShow
      shortName
      fullName
      shield
      shieldBig
      shieldPng
      players {
        id
        nick
        name
        lastName
        role
        marketValue
        image
        totalScore
        lastWeekScore
        lastWeekNumber
        team {
          id
          nameShow
          shield
          shieldPng
        }
      }
    }
  }
`;
